import { useState } from "react";
import { useTranslation } from "react-i18next";
import { faq } from "../data/faq";
import "../styles/InfoSections.css";

// One collapsible row. The answer is always in the HTML (crawlers read it); closed rows are
// collapsed with a CSS height transition and hidden from screen readers.
const FaqItem = ({ item, id }) => {
  const [open, setOpen] = useState(false);

  return (
    <div className={open ? "info-item faq-item is-open" : "info-item faq-item"}>
      <h3 className="info-item-head">
        <button
          type="button"
          className="faq-question"
          aria-expanded={open}
          aria-controls={id}
          onClick={() => setOpen(!open)}
        >
          {item.question}
        </button>
      </h3>
      <div className="faq-answer" id={id}>
        <div className="faq-answer-inner">
          <p className="info-item-prg">{item.answer}</p>
        </div>
      </div>
    </div>
  );
};

// FAQPage structured data, built from the same array as the visible questions so the two
// can't drift. "<" is escaped so an answer can never close the script tag.
const faqJsonLd = (items) =>
  JSON.stringify({
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: items.map((item) => ({
      "@type": "Question",
      name: item.question,
      acceptedAnswer: { "@type": "Answer", text: item.answer },
    })),
  }).replace(/</g, "\\u003c");

const Faq = () => {
  const { t, i18n } = useTranslation();
  const items = faq[i18n.language] ?? faq.tr;

  return (
    <section id="sss" className="info-section">
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: faqJsonLd(items) }} />
      <h2 className="info-section-head">{t("faqHeader")}</h2>
      <div className="info-list">
        {items.map((item, index) => (
          <FaqItem item={item} id={`sss-cevap-${index + 1}`} key={item.question} />
        ))}
      </div>
    </section>
  );
};
export default Faq;
